import { render } from "./MessageDropdown.vue?vue&type=template&id=28de3296"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"

import "./MessageDropdown.vue?vue&type=style&index=0&id=28de3296&lang=scss"
script.render = render

export default script